<template>
    <div> 
        <b-modal
                id="calculatorModal"
                title-html="<i class='fa fa-calculator'></i>&nbsp;&nbsp;Rekenhulp"
                size="lg"
                :visible="open"
                ok-title="Neem gegevens over"
                ok-variant="success"
                @ok="calculatorCopyData"
                cancel-title="Annuleren"
                cancel-variant="danger"
                @cancel="calculatorClose"
                @close="calculatorEmitClose"
                @hide="calculatorEmitClose"
        >
        <form-loader v-if="loading" message="Laden..."/>
          <template v-if="!loading">
            <b-row>
                    <b-col>
                        <p>
                            Met deze rekenhulp maakt u een schatting van uw jaarinkomen. Beantwoord de vragen zo zorgvuldig mogelijk. Want de hoogte van uw inkomen bepaalt op welke woningen u mag reageren. Gebruik hiervoor het bedrag op je meest recente loonstrookje / uitkering. Vraag bij twijfel aan uw werkgever of uitkeringsinstantie na hoe hoog uw inkomen is.
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="bruto">Loon voor loonheffing</label>
                    </b-col>
                    <b-col cols="1" sm="1" class="calculatorIconEuro">
                        <i class="fa fax fa-euro-sign"></i>
                    </b-col>
                    <b-col sm="4" cols="5">
                        <b-form-input
                                type="number"
                                min="0"
                                step="1"
                                id="bruto"
                                v-model="bruto"
                                size="sm"
                                placeholder=""
                                @keyup="calculatorDoMath"
                        />
                    </b-col>
                    <b-col sm="2" cols="5">
                        <b-form-select
                            v-model="bruto_interval"
                            :options="formData.interval"
                            @input="calculatorDoMath"
                        />
                    </b-col>
                </b-row> 
                <b-row>
                  <b-col sm="5" class="form-label">
                    <label for="yearSelection">Loongegevens komen uit:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-radio-group id="yearSelection" v-model="selectedYear" @change="calculatorDoMath">
                      <b-form-radio v-for="option in yearOptions" :key="option.value" :value="option.value">{{ option.text }}</b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="vacation">Ontvangt u vakantiegeld?</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-radio-group id="checkbox-vacation" v-model="vacation" @input="calculatorDoMath">
                            <b-form-radio :value="true">Ja</b-form-radio>
                            <b-form-radio :value="false">Nee</b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="vacation">Krijgt u een 13e maand?</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-radio-group id="checkbox-extraMonth" v-model="extraMonth" @input="calculatorDoMath">
                            <b-form-radio :value="true">Ja</b-form-radio>
                            <b-form-radio :value="false">Nee</b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="5" class="form-label">
                        <label for="vacation">Ontvangt u partneralimentatie?</label>
                    </b-col>
                    <b-col sm="5">
                        <b-form-radio-group id="checkbox-alimony" v-model="alimony" @input="calculatorDoMath">
                            <b-form-radio :value="true">Ja</b-form-radio>
                            <b-form-radio :value="false">Nee</b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="1" sm="1" offset-sm="5" v-if="alimony" class="calculatorIconEuro">
                        <i class="fa fax fa-euro-sign"></i>
                    </b-col>
                    <b-col cols="5" sm="4" v-if="alimony">
                        <b-form-input
                                type="number"
                                min="0"
                                step="1"
                                id="alimony_count"
                                v-model="alimony_count"
                                size="sm"
                                placeholder=""
                                @keyup="calculatorDoMath"
                        />
                    </b-col>
                    <b-col cols="5" sm="2" v-if="alimony">
                        <b-form-select
                                v-model="alimony_interval"
                                :options="formData.interval"
                                @input="calculatorDoMath"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="spacer"></b-col>
                </b-row>
                <b-row>
                    <b-col cols="10" offset="1" sm="8" offset-sm="2">
                        <b-card>
                            <b-card-body class="text-center">
                                <h2>
                                    Uw inkomen per jaar:
                                </h2>
                                <h3>
                                    <strong>
                                        <i>
                                            &euro; {{ total }}
                                        </i>
                                    </strong>
                                </h3>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
          </template> 
        </b-modal>
    </div>
</template>

<script>
import { registrationService } from '@/_services/registration.service'
  export default {
    name: 'IncomeCalculator',

    props: [
      'open'
    ],
    data: () => {
       const currentYear = new Date().getFullYear();
      return {
        total: 0,
        bruto: 0,
        bruto_interval: 'month',
        vacation: true,
        extraMonth: false,
        alimony: false,
        alimony_count: 0,
        alimony_interval: 'month',
        incomeSettings:{
          T1: null,
          T2: null,
        },
        currentYear:currentYear,
        selectedYear: currentYear,
        loading:false,
        yearOptions: [],
        formData: {
          interval: [
            { text: 'Maand', value: 'month' },{ text: '4 weken', value: 'fourweeks' },{ text: 'Week', value: 'week' }]
        }
      }
    },
    mounted() { 
      this.getIncomeData()
    },   
    created() {
      this.generateYearOptions();
    },
    methods: {
      getIncomeData() {
        console.log('getIncomeData')
        this.loading = true
        registrationService.getIncomeSettings().then((data) => {
          this.incomeSettings = data
          this.loading = false 
        });
      },
      calculatorDoMath() {
        let subtotal = 0;
        let bruto = isNaN(parseFloat(this.bruto)) ? 0 : parseFloat(this.bruto)
        let alimony = isNaN(parseFloat(this.alimony_count)) ? 0 : parseFloat(this.alimony_count)
        
        let t_factor=1
        let yearDifference = parseInt(this.currentYear) - parseInt(this.selectedYear)
        if(yearDifference==1){
          t_factor = parseFloat(this.incomeSettings.T1)
        }
        if (yearDifference == 2) {
          t_factor = this.incomeSettings.T2
        } 
        bruto = bruto* t_factor 
        if(this.bruto_interval === 'month') {
          subtotal = bruto * 12
        } else if(this.bruto_interval === 'fourweeks') {
          subtotal = bruto * 13
        } else if(this.bruto_interval === 'week') {
          subtotal = bruto * 52
        }
        if(this.extraMonth) {
          subtotal = subtotal / 12 * 13
        }
        if(this.vacation) {
          subtotal = subtotal * 1.08
        }
        if(this.alimony) {
          if(this.alimony_interval === 'month') {
            subtotal = subtotal + ( alimony * 12 )
          } else if(this.alimony_interval === 'fourweeks') {
            subtotal = subtotal + ( alimony * 13 )
          } else if(this.alimony_interval === 'week') {
            subtotal = subtotal + ( alimony * 52 )
          }
        }

        this.total = Math.floor(subtotal)
      },
      calculatorClose() {
        this.$bvModal.hide('calculatorModal')
        this.calculatorEmitClose()
      },
      calculatorCopyData() {
        this.$emit('calculatorEmitVal', this.total);
        this.calculatorClose()
      },
      calculatorEmitClose() {
        this.$emit('calculatorClosed', 'empty');
      },
      generateYearOptions() {
        const currentYear = new Date().getFullYear();
        this.yearOptions = [
          { value: currentYear, text: currentYear.toString() },
          { value: currentYear - 1, text: (currentYear - 1).toString() },
          { value: currentYear - 2, text: (currentYear - 2).toString() },
        ];
        this.selectedYear = this.yearOptions[0].value; // Default to current year
      },
    }
  }
</script>

<style scoped>

</style>